"use strict";
/**
 * Created by Jonas Wålekvist on 2019-11-15.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APISetting = void 0;
var APISetting;
(function (APISetting) {
    APISetting["LEFT_HAND_MODE"] = "leftHanded";
    APISetting["CLOCK"] = "clock";
    APISetting["MUSIC"] = "music";
    APISetting["SFX"] = "sfx";
    APISetting["FAST_SPIN"] = "fastspin";
    APISetting["DEVICE_HAS_ROUNDED_CORNERS"] = "deviceHasRoundedCorners";
    APISetting["USE_SPACE_TO_SPIN"] = "useSpaceToSpin";
    APISetting["BALANCE_ID"] = "balanceId";
})(APISetting = exports.APISetting || (exports.APISetting = {}));
//# sourceMappingURL=APISettingsSystem.js.map